import React from "react";

function CloseIcon({ w = 20, h = 20 }) {
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.237 15.4329L14.6681 1.19959"
        stroke="#6E6F71"
        strokeLinecap="round"
      />
      <path d="M1 1.19049L15 15.1539" stroke="#6E6F71" strokeLinecap="round" />
    </svg>
  );
}

export default CloseIcon;
